function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualInvoices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.32,70.2s-69.7,48.72-98.89,112.87S22.77,322.53,76.12,372.46s139.23,30.36,217,55.83,157,6.91,180.9-73.4-32-101.27-53.09-187.39S303.16-35.56,137.32,70.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.32,70.2s-69.7,48.72-98.89,112.87S22.77,322.53,76.12,372.46s139.23,30.36,217,55.83,157,6.91,180.9-73.4-32-101.27-53.09-187.39S303.16-35.56,137.32,70.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 106,
    width: 78,
    height: 103,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.09,
    y: 118,
    width: 59.83,
    height: 79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 159,
    width: 78,
    height: 103,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.09,
    y: 171,
    width: 59.83,
    height: 79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 363.96,
    cy: 140.83,
    r: 45.04,
    transform: "translate(-12.22 36.97) rotate(-5.72)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.96,
    cy: 140.83,
    r: 37.32,
    transform: "translate(-16.77 55.11) rotate(-8.46)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "340.15 140.83 363.96 140.83 363.96 175.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.7,355.31l15.8,25.45a4.87,4.87,0,0,1-4.14,7.44H313.09a4.87,4.87,0,0,0,4.15-7.42L302,355.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.7 355.31 301.95 355.88 307.83 365.46 340 365.46 333.7 355.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.37,
    y: 247,
    width: 134.96,
    height: 113.98,
    rx: 2.91,
    transform: "translate(627.71 607.98) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.27,
    y: 247,
    width: 134.96,
    height: 113.98,
    rx: 2.91,
    transform: "translate(617.5 607.98) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.81,247H371.7a4.53,4.53,0,0,1,4.53,4.54v89h-135v-89A4.54,4.54,0,0,1,245.81,247Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.94,
    y: 251.54,
    width: 123.62,
    height: 82.79,
    transform: "translate(617.5 585.87) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,260.62h1.48V270H289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.87,263.22V270h-1.33v-9.41h1.86l1.52,5.63v-5.63h1.32V270h-1.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.53,268.3l1.13-7.68H302L300.57,270h-2.21l-1.45-9.41h1.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.57,262.88a2.25,2.25,0,1,1,4.49,0v4.89a2.25,2.25,0,1,1-4.49,0Zm1.48,5c0,.67.3.92.77.92s.76-.25.76-.92v-5.08c0-.68-.29-.93-.76-.93s-.77.25-.77.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,260.62h1.48V270H308Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,266.52v1.25c0,1.51-.75,2.37-2.2,2.37a2.07,2.07,0,0,1-2.21-2.37v-4.89a2.07,2.07,0,0,1,2.21-2.37c1.45,0,2.2.86,2.2,2.37v.91h-1.39v-1c0-.68-.3-.93-.77-.93s-.77.25-.77.93v5.08c0,.67.3.91.77.91s.77-.24.77-.91v-1.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.24,264.59h2v1.34h-2v2.76h2.56V270h-4v-9.41h4V262h-2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.08,
    y: 273.75,
    width: 114.1,
    height: 7.06,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "252.45 326.52 252.45 285.64 365.44 285.64 365.44 328.01",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.83,
    y1: 299.39,
    x2: 365.07,
    y2: 299.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.22,
    y1: 285.34,
    x2: 334.22,
    y2: 328.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.68,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.91,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.15,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.38,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.62,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.85,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.09,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.32,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.56,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.79,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.03,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.26,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.5,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.73,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.97,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.2,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.44,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.67,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.91,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.14,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.38,
    y: 382.5,
    width: 3.93,
    height: 1.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.65,
    y: 384,
    width: 113.51,
    height: 4.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.47,
    y: 384,
    width: 27.69,
    height: 4.23,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.88 292.63 408.88 278 398.38 278 398.38 292.63 391.39 292.63 403.63 313.83 415.86 292.63 408.88 292.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328,
    y1: 240.5,
    x2: 328,
    y2: 239,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,236.05V225.5a7,7,0,0,1,7-7h62a7,7,0,0,1,7,7V271",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "2.9481399059295654,2.9481399059295654"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404,
    y1: 272.5,
    x2: 404,
    y2: 274,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.75,322.5h63.5a6.25,6.25,0,0,1,6.25,6.25v50.51a0,0,0,0,1,0,0h-76a0,0,0,0,1,0,0V328.75A6.25,6.25,0,0,1,367.75,322.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.5,
    y: 315.5,
    width: 68,
    height: 63.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,346.09H446.07a3.82,3.82,0,0,1,3.82,3.82v37.85a0,0,0,0,1,0,0h-123a0,0,0,0,1,0,0V346.09A0,0,0,0,1,326.86,346.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.06,346.09H429.31a2.39,2.39,0,0,1,2.39,2.39v39.28a0,0,0,0,1,0,0h-123a0,0,0,0,1,0,0V348.48A2.39,2.39,0,0,1,311.06,346.09Z",
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,346.09H421.12a0,0,0,0,1,0,0v27.28a8.43,8.43,0,0,1-8.43,8.43h-85a8.43,8.43,0,0,1-8.43-8.43V346.09A0,0,0,0,1,319.26,346.09Z",
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.11,
    y: 346.09,
    width: 64.16,
    height: 41.67,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.73,367.77s2.18,10.37-2.74,14.2-29.49,3-29.49,3h80.29s9.83,2.46,9.28-15.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.96 383.42 341.56 383.42 344.37 381.85 394.98 381.85 392.96 383.42",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.25,371.42c0,6.34-1.5,8.67-1.5,8.67h49.53s2.17-1.33,2.67-8.5",
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.59,
    y1: 377.09,
    x2: 397.78,
    y2: 377.09,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.09,
    y1: 373.92,
    x2: 398.45,
    y2: 373.92,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.44,379.92s2.5-2.33,2.33-8.5",
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.11,
    y: 346.09,
    width: 64.16,
    height: 23.91,
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.29,
    y: 385.02,
    width: 69.97,
    height: 2.74,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,346.09h68.79a0,0,0,0,1,0,0v3.31A6.61,6.61,0,0,1,398,356H342.41a6.61,6.61,0,0,1-6.61-6.61v-3.31A0,0,0,0,1,335.79,346.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73,353.53a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,427.73,353.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73,363.12a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,427.73,363.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.09,384.35h-1.3a1.78,1.78,0,0,1-1.78-1.78h0a1.79,1.79,0,0,1,1.78-1.79h1.3a1.78,1.78,0,0,1,1.78,1.79h0A1.78,1.78,0,0,1,426.09,384.35Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-15"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "369.02 442.77 369.02 399.26 349.85 399.26 349.85 442.92",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.44,
    y: 399.26,
    width: 9.59,
    height: 44.05,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "454.89 442.77 454.89 399.26 435.71 399.26 435.71 442.92",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.3,
    y: 399.26,
    width: 9.59,
    height: 44.05,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 391.81,
    width: 391,
    height: 15.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.92,
    y: 391.81,
    width: 94.08,
    height: 15.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 387.67,
    width: 391,
    height: 5.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.45,
    y: 387.67,
    width: 85.55,
    height: 5.33,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.56,180.07s.71,6.17.24,8.54-3.08,3.8-2.85,5.46,6.17,10.2,3.32,13.05a14,14,0,0,1-5.22,3.56L187.16,215s-11.39,7.36-15.9,9.26-.48,10.91-.48,10.91l-11.63-2.61L156.31,246s-8.78-8.55-20.65-12.34-16.37-3.32-16.37-3.32a74.75,74.75,0,0,0,4.27-14.72c1.66-8.78,2.61-28.24,2.61-29.66s7.59-23.25,14.24-27.53,33.69.48,47.93,4,8.07,13.76,8.07,13.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.09,187.66s-.71-2.61-3.8-1.66-3.8,2.61-2.61,2.61,4-1.42,4.75,0S192.85,189.32,193.09,187.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.82,196.2l-1.43.72s2.14,1.42,1.19,4.74-1.9,6.17-1.9,6.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.27,173.66s2.14,9,1.19,10.92-8.07,4.51-8.78,7.12-2.13,16.61-1.66,19.22,1.66,7.12,2.85,7.12,10-6.65,13.29-6.89,1.89,5.7.23,7.6-5,2.37-4.74,4.51,4.51,9.49-.24,15.9-10.2,5-15.9.47-6.64-12.1-5-16.37,4.27-15.43,4.51-20.41-.95-11.39-4.51-10-.71,15.43-3.32,18.51-13.06,11.87-15.9,11.87-18.28-6.88-18.75-7.6,1.42-32.51-.47-45.08,2.61-21.6,17.08-25.87S181,148.27,181,148.27s-2.61-4.27,3.08-6.17,19.22,3.32,20.17,11.87-4,8.78-3.32,11.62,9.73,8.31,5,12.82-12.34,1.66-12.34,1.66l-.95-7.36S187.63,166.54,180.27,173.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,191.46l-22.54-.71s-4.75,1.18-5.22,3.79-.95,8.78.47,9,1.43-1.42,1.43-3.56,0-5.46,1.89-6.64a13.93,13.93,0,0,1,5.22-1.43l19.23,1.9,18,1.43v-3.09Z",
    style: {
      fill: "#5e5e5e",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32,200.71s.72-7.59-3.08-9.73-6.41,3.8-6.64,9,3.32,11.63,7.83,10.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,195.26s.47,5.45-1.66,8.06a11,11,0,0,1-2.85,2.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,239.44l-9.54,33.39-7.15,19.08-7.75,20.56s-21.47-.29-31-2.08S184,302.5,184,302.5A172.9,172.9,0,0,0,203.5,259c4.05-14.16,7.19-25.52,7.19-25.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36,254.74s-7.14,25.63-10.06,30.82L243,290.75s6.49-11.36,11.36-31.15Z",
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.41,
    y1: 260.58,
    x2: 252.42,
    y2: 265.44,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.79,
    y1: 269.01,
    x2: 249.39,
    y2: 273.6,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.94,
    y1: 277.58,
    x2: 246.66,
    y2: 282.45,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "234.57 280.84 227.76 299.51 238.79 301.78 242.69 288.8",
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 287.5,
    x2: 209.27,
    y2: 290.1,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.03,
    y1: 289.45,
    x2: 208.3,
    y2: 292.05,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.05,
    y1: 291.4,
    x2: 207.33,
    y2: 293.99,
    style: {
      fill: "none",
      stroke: "#a3a3a3",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.2 235.81 207.9 250.72 258.1 256.75 262.97 241.83 212.2 235.81",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,238.75l1.09.11-2,7-1.09-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.34,241l-1.43,5-1-.1,2-7,1.36.14-.06,4.28,1.18-4.16,1,.1-2,6.95-1.12-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18,245.22l2.45-5.59,1,.11-3,6.84-1.63-.17.91-7.06,1.1.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.56,241.45a1.94,1.94,0,0,1,2.16-1.58c1.07.11,1.47.81,1.15,1.92l-1,3.61a1.92,1.92,0,0,1-2.15,1.58c-1.07-.11-1.48-.8-1.16-1.92Zm0,3.8c-.14.49,0,.7.37.74s.62-.13.76-.63l1.07-3.75c.14-.5,0-.71-.37-.75s-.62.13-.76.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.05,240.19l1.09.11-2,7-1.09-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.86,245.07l-.27.93a1.89,1.89,0,0,1-2.12,1.58c-1.07-.11-1.44-.81-1.13-1.92l1-3.61a1.91,1.91,0,0,1,2.13-1.59c1.07.11,1.44.81,1.13,1.92l-.2.68-1-.11.21-.75c.15-.49,0-.7-.37-.74s-.61.13-.76.63l-1.07,3.75c-.14.5,0,.7.38.74s.61-.12.75-.62l.29-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,243.82l1.5.16-.29,1-1.49-.15-.58,2,1.88.2-.28,1-3-.31,2-6.95,3,.31-.28,1-1.89-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,246.28a3.76,3.76,0,1,1-3.73-3.3A3.53,3.53,0,0,1,257,246.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.43,342.58s8.94-21.16,9.83-29.51,1.49-16.1,3.58-18.48,6.86-13.71,7.75-17,3-6.56,5.36-4.18,1.5,8.05.6,10.14-2.09,5.37-2.09,5.37l6.26-6.86,3.88-9.24s3.28,0,3.87,3,4.18,7.45,3.28,10.13a7.16,7.16,0,0,1-3.57,3.88s1.49,7.45,1.19,10.13A15.18,15.18,0,0,1,256,308.9c-3,2.38-11.32,10.13-11.32,10.13s4.17,31.6,0,47.1-11.63,20.27-17,21.17-15.79-11-15.79-11S222.92,370.6,221.43,342.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.18,
    y1: 289.82,
    x2: 255.41,
    y2: 294.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.72,
    y1: 282.07,
    x2: 257.49,
    y2: 278.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,224.33s8.33-2,21,3.34a58.13,58.13,0,0,1,23.67,17.66,51.9,51.9,0,0,1,6.66,12S119,238.67,113.67,238.67h-12S108,225,116,224.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,443.33c-38.67-34-99-34-99-34l-9-8.66H66.92v43.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.67,411.33s-5,21.67-14.67,31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.67,409.67a49,49,0,0,1-17.67,21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,234.67s7.33-1.67,21.67,1.33,35.33,15.33,44.66,19.33,16.67,4.34,18.34,10.34,20,62.66,28,69c11.79,9.34,23,25.74,10,39.33-7.67,8-18,8.67-22.67,7s-16-13.33-16-17v-4.67L165,334s4.67,39.67,6.67,45S179,392,179,395.33s-7.67,10-16.67,15.67-18,10.67-38.66,11.67S78.33,420.33,73,413.33s-12-15.33-12.67-27-3-57.66-3-57.66,1.34-37.34,2.34-49.67,3.66-20.33,10-23S98.67,234.67,103,234.67Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.35,311.54a41.23,41.23,0,0,0,3,4.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,265s3.58,25,12.54,42.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.67,296.33s7.33,23.67,18.66,36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.33,
    y1: 314,
    x2: 165,
    y2: 334,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.33,
    y1: 308,
    x2: 145.93,
    y2: 311.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 317,
    x2: 159.67,
    y2: 328.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.33,273S150.67,288,151,305.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,334.67s5.66,11-2.67,19-26,5.66-26,5.66V364c0,3.67,11.33,15.33,16,17s15,1,22.67-7C238.69,360.41,227.46,344,215.67,334.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.67,
    y1: 379,
    x2: 153.67,
    y2: 362,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.67,
    y1: 352.33,
    x2: 161.33,
    y2: 365,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.34,370.17a33.33,33.33,0,0,0,4,2.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.67,341s20.06,15.66,32.82,25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.67,351s14.66,10.67,17,12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.75,358.5h79a9.25,9.25,0,0,1,9.25,9.25v67.5a6.75,6.75,0,0,1-6.75,6.75h-84a6.75,6.75,0,0,1-6.75-6.75v-67.5A9.25,9.25,0,0,1,66.75,358.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.75,358.5h79a9.25,9.25,0,0,1,9.25,9.25v67.5a6.75,6.75,0,0,1-6.75,6.75h-84a6.75,6.75,0,0,1-6.75-6.75v-67.5A9.25,9.25,0,0,1,58.75,358.5Z",
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,447.81V383a3,3,0,0,0-6,0v64.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,447.81V383a3,3,0,0,0-6,0v64.81Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualInvoices);
export default __webpack_public_path__ + "static/media/Manual-Invoices.77dce6df.svg";
export { ForwardRef as ReactComponent };